// Field row used by `add-global-theme-modal.js`'s color-token picker list —
// registered here (2026-08-14, bare-string extends registration sweep)
// because a bare-string `childExtends: 'ColorSelectWithTitle'` resolves
// ONLY against the live `context.components` registry (smbls's
// `resolveExtend`, smbls/packages/element/src/extends.js). This exact
// component already existed at
// workspace/packages/design-system/components/ColorSelectWithTitle.js, but
// its export is commented out of that package's barrel ("depends on
// GroupField") and design-system is never a shared library of `shared` (or
// of anything `shared` is consumed by), so it was unreachable from here
// regardless — a genuinely different registration gap than a page-local
// definition, same underlying defect class: every color-token row on the
// global-theme modal silently mounted as a bare unstyled div. `GroupField`
// is a brand component, always present alongside `shared` in every real
// host in this monorepo.
export const ColorSelectWithTitle = {
  extends: 'GroupField',
  minWidth: 'F2',
  Title: {
    text: '{{ editor.color.select | polyglot }}'
  },
  ColorSelect: {
    width: '100%',
    Dropdown: {
      width: '100%',
      top: '110%'
    }
  }
}
